import React from "react";
import { Tag } from "antd";
import { DollarCircleOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";

export interface BusinessTagDiscountProps {
  discount?: number;
}

const BusinessTagDiscount: React.FC<BusinessTagDiscountProps> = ({ discount = 20 }) => {
  const { t } = useTranslation();

  return (
    <Tag icon={<DollarCircleOutlined />} color="green">
      {t("business.tags.discount", { discount: `${discount}%` })}
    </Tag>
  );
};

export default BusinessTagDiscount;
